/**
 * LAS FOTOS QUE TE ADJUNTA TU ENTRENADOR CON SU FEEDBACK. Estaba dentro de ReportsPage; sale
 * aquí (22-10) porque ahora las pinta también el informe del mes, dentro de su feedback.
 */
import React, { useEffect, useState } from 'react';

// LAS FOTOS QUE TE ADJUNTA TU ENTRENADOR CON SU FEEDBACK (21-10). Las elige de las tuyas en
// tu ficha; aquí se piden por su `ref`, como el resto de tus fotos (/reports/foto/{ref}), al
// ancho en que se ven. Al tocarlas se abre la original.
const _caminoDeLaRef = (ref) => String(ref).split('/').map(encodeURIComponent).join('/');
const NOMBRE_DE_POSE = { frente: 'Frente', espalda: 'Espalda', perfil: 'Perfil' };

const FotoDelFeedback = ({ api, foto }) => {
    const [src, setSrc] = useState(null);
    const [fallo, setFallo] = useState(false);
    useEffect(() => {
        let vivo = true; let url = null;
        api.get(`/reports/foto/${_caminoDeLaRef(foto.ref)}?w=600`, { responseType: 'blob' })
            .then(r => { if (!vivo) return; url = URL.createObjectURL(r.data); setSrc(url); })
            .catch(() => { if (vivo) setFallo(true); });
        return () => { vivo = false; if (url) URL.revokeObjectURL(url); };
    }, [api, foto.ref]);
    const abrir = async () => {
        try {
            const r = await api.get(`/reports/foto/${_caminoDeLaRef(foto.ref)}`, { responseType: 'blob' });
            window.open(URL.createObjectURL(r.data), '_blank', 'noopener');
        } catch { /* sin la original, se queda la que se ve */ }
    };
    return (
        <button type="button" onClick={abrir} className="block w-full text-left" aria-label={`Ver en grande ${NOMBRE_DE_POSE[foto.pose] || 'la foto'}`}>
            {src
                ? <img src={src} alt="" className="w-full aspect-[3/4] object-cover rounded-lg bg-muted" />
                : <div className={`w-full aspect-[3/4] rounded-lg bg-muted flex items-center justify-center text-[11px] text-muted-foreground ${fallo ? '' : 'animate-pulse'}`}>
                    {fallo ? 'Foto no disponible' : ''}
                  </div>}
            {(foto.pose || foto.fecha) && (
                <span className="block mt-1 text-[11px] text-foreground/50 truncate">
                    {[NOMBRE_DE_POSE[foto.pose], foto.fecha && new Date(`${foto.fecha}T12:00:00`).toLocaleDateString('es-ES', { day: 'numeric', month: 'short', year: 'numeric' })].filter(Boolean).join(' · ')}
                </span>
            )}
        </button>
    );
};

const FotosDelFeedback = ({ api, fotos }) => (
    (fotos || []).length > 0 && (
        <div className="grid grid-cols-3 gap-2 mt-2.5" data-testid="fotos-del-feedback">
            {fotos.map(f => <FotoDelFeedback key={f.ref} api={api} foto={f} />)}
        </div>
    )
);

export default FotosDelFeedback;
